<template>
  <DataTable
    :value="users"
    :class="[
      users && users.length == 0 ? 'empty-table' : '',
      isActiveFirst ? 'active-first' : '',
    ]"
    class="scroll-table-y main-table scrollbar-custom"
    stripedRows
    @sort="sortTable"
    removableSort
    scrollable
    :loading="isLoading"
    dataKey="id"
    columnResizeMode="expand"
  >
    <Column field="number" header="№" style="min-width: 44px">
      <template #body="slotProps">
        {{ rowsCount + slotProps.index + 1 }}
      </template>
    </Column>
    <Column field="email" sortable header="Логин/почта">
      <template #body="slotProps">
        <RouterLink :to="{ name: 'user', params: { id: slotProps.data.id } }">
          {{ slotProps.data.email }}
        </RouterLink>
      </template>
    </Column>
    <Column field="lname" header="Имя" sortable>
      <template #body="slotProps">
        {{ getUserFullName(slotProps.data) }}
      </template>
    </Column>
    <Column field="organization" header="Организация">
      <template #body="slotProps">
        <span v-if="slotProps.data.role">{{
          slotProps.data.role.department.organization.name
        }}</span>
        <span v-else>-</span>
      </template>
    </Column>
    <Column field="is_demo" header="Демо-организация">
      <template #body="slotProps">
        <span v-if="slotProps.data.role?.department?.organization?.is_demo">Да</span>
        <span v-else>Нет</span>
      </template>
    </Column>
    <Column field="department" header="Департамент">
      <template #body="slotProps">
        <span v-if="slotProps.data.role">{{
          slotProps.data.role.department.name
        }}</span>
        <span v-else>-</span>
      </template>
    </Column>
    <Column field="role" header="Роль">
      <template #body="slotProps">
        <span v-if="slotProps.data.role">{{ slotProps.data.role.name }}</span>
        <span v-else>-</span>
      </template>
    </Column>
    <Column
      field="ctime"
      header="Дата создания"
      sortable
      style="min-width: 153px"
    >
      <template #body="slotProps">
        {{ convertDateFromUTC(slotProps.data.ctime) }}
      </template>
    </Column>
    <Column
      field="mtime"
      header="Дата обновления"
      sortable
      style="min-width: 173px; max-width: 173px"
    >
      <template #body="slotProps">
        {{ convertDateFromUTC(slotProps.data.mtime) }}
      </template>
    </Column>
    <Column frozen alignFrozen="right">
      <template #body="slotProps">
        <div
          @click="(event) => toggle(slotProps.data.id, event)"
          aria-haspopup="true"
          aria-controls="overlay_menu"
          class="button-menu"
        >
          <span :data-segment="1" class="pi pi-ellipsis-v"></span>
        </div>
      </template>
    </Column>
  </DataTable>
  <Menu ref="menu" id="overlay_menu" :model="filteredItems" :popup="true" />
  <UsersHistoryDialog
    entity="users"
    :object_id="modifiedId"
    :visible="confirmVisible.history"
    @close="confirmVisible.history = false"
  ></UsersHistoryDialog>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useRouter } from "vue-router";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import UsersHistoryDialog from "@/widgets/dialogs/UsersHistoryDialog.vue";

import { convertDateFromUTC } from "@/services/utils/DateParser";
import { getUserFullName } from "@/services/utils/Names";
import { useAuthStore } from "@/store/auth/login";

defineProps<{
  users: any[];
  isActiveFirst: boolean;
  isLoading: boolean;
  rowsCount: number;
}>();
const emits = defineEmits(["sortTable", "updateTable"]);
const router = useRouter();
const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});

let modifiedId = ref(0);
const menu = ref();
const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
  {
    label: "Редактировать",
    icon: "pi pi-pencil",
    archive: "no_archive",
    command: () => {
      router.push({ name: "user", params: { id: modifiedId.value } });
    },
  },
]);

const filteredItems = computed(() => {
  return items.value.filter((item) => !(item.checkDenied && isDenied.value));
});

const confirmVisible = ref({
  history: false,
});

const toggle = (elemId: number, event: any) => {
  modifiedId.value = elemId;
  menu.value.toggle(event);
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};
</script>
